import { render, staticRenderFns } from "./ItemAuthorItemContainer.vue?vue&type=template&id=aaeba4ba"
import script from "./ItemAuthorItemContainer.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorItemContainer.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorItemContainer.vue?vue&type=style&index=0&id=aaeba4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports